import * as z from "zod";

// Leaf module: user.ts needs this, and project.ts imports user.ts (cycle).
export const projectHostingTypeSchema = z.enum(["replo", "shopify"]);
